import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { CheckCircle, Clock, Database, Zap } from 'lucide-react'

const steps = [
  {
    step: 1,
    title: 'Submit Request',
    description: 'Enter an Instagram username to analyze',
    icon: Zap,
    color: 'text-blue-600 dark:text-blue-400',
    bg: 'bg-blue-50/50 dark:bg-blue-950/20'
  },
  {
    step: 2,
    title: 'Queue Processing',
    description: 'Your request will be queued for background processing',
    icon: Clock,
    color: 'text-orange-600 dark:text-orange-400',
    bg: 'bg-orange-50/50 dark:bg-orange-950/20'
  },
  {
    step: 3,
    title: 'Data Analysis',
    description: 'We analyze posts, engagement, and audience metrics',
    icon: Database,
    color: 'text-purple-600 dark:text-purple-400',
    bg: 'bg-purple-50/50 dark:bg-purple-950/20'
  },
  {
    step: 4,
    title: 'Results Ready',
    description: 'Analytics results appear in your saved influencers',
    icon: CheckCircle,
    color: 'text-green-600 dark:text-green-400',
    bg: 'bg-green-50/50 dark:bg-green-950/20'
  }
]

// Removed fade-up variants

export function RequestInfo() {
  return (
    <div>
      <Card className="border border-slate-200/30 dark:border-slate-800/30">
        <CardHeader className="pb-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-slate-50/50 dark:bg-slate-950/20 flex-shrink-0">
              <Database className="h-4 w-4 text-slate-600 dark:text-slate-400" />
            </div>
            <div>
              <CardTitle className="text-lg font-semibold">How it works</CardTitle>
              <p className="text-sm text-muted-foreground mt-1">
                Processing may take some time depending on queue size (less than 12 hours). 
              </p>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div 
            className="space-y-4"
          >
            {steps.map((step) => (
              <div
                key={step.step}
                className="flex items-start gap-3 p-3 rounded-lg bg-muted/30"
              >
                <div className="flex items-center gap-2 flex-shrink-0">
                  <Badge variant="outline" className="text-xs font-semibold w-6 h-6 p-0 flex items-center justify-center">
                    {step.step}
                  </Badge>
                  <div className={`p-1.5 rounded-md ${step.bg}`}>
                    <step.icon className={`h-3 w-3 ${step.color}`} />
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-semibold text-foreground">{step.title}</h4>
                  <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
} 